import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DeleteButton,
} from 'react-admin';

const NewsList = ({ classes, ...props }) => {
  return (
    <List
      title="Новости"
      exporter={false}
      {...props}
      bulkActionButtons={false}
      pagination={<></>}
    >
      <Datagrid>
        <TextField label="Заголовок" source="title" sortable={false} />
        <DeleteButton undoable={false} />
      </Datagrid>
    </List>
  );
};

export default NewsList;
